import React, {useState} from 'react';
import OrgUsersModal from './modals/OrgUsersModal';
import OrgLimitsModal from './modals/OrgLimitsModal';
import moment from 'moment';
import './style.scss';

const OrganizationListItem = ({item, refreshList}) => {
    const [isOrgUsersModalOpen, setIsOrgUsersModalOpen] = useState(false);
    const [isLimitsModalOpen, setIsLimitsModalOpen] = useState(false);

    const convertDateString = (date) => {
        return moment(date).format('MM/DD/YYYY hh:mm');
    };

    return (
        <tr className="table_row">
            {isOrgUsersModalOpen && (
                <OrgUsersModal
                    isOpen={isOrgUsersModalOpen}
                    toggle={() => setIsOrgUsersModalOpen(false)}
                    orgId={item.id}
                    orgName={item.name}
                />
            )}
            {isLimitsModalOpen && (
                <OrgLimitsModal
                    isOpen={isLimitsModalOpen}
                    toggle={() => setIsLimitsModalOpen(false)}
                    settings={item.settings}
                    orgId={item.id}
                    itemName={item.name}
                    refreshList={refreshList}
                />
            )}
            <td className="table_column">
                <strong className="table_lable">Organization</strong>
                <div
                    onClick={() => setIsOrgUsersModalOpen(true)}
                    className="table-title_container org_title"
                >
                    <span>{item.name}</span>
                </div>
            </td>
            <td className="table_column">
                <strong className="table_lable">Type</strong>
                <span>
                    {!item.isSingleUser
                        ? <div>TEAMS</div>//<i style={{color: 'green'}} className="fas fa-check-circle"></i>
                        : <div>SINGLE</div>//<i style={{color: '#db3c3c'}} className="fas fa-times-circle"></i>
                    }
                </span>
            </td>
            <td className="table_column">
                <strong className="table_lable">Time Zone</strong>
                {item.timezone}
            </td>
            {/*<td className="table_column">*/}
            {/*    <strong className="table_lable">User's Time Zone</strong>*/}
            {/*    {item.user_time_zone}*/}
            {/*</td>*/}
            <td className="table_column">
                <strong className="table_lable">Created At</strong>
                {convertDateString(item.createdAt)}
            </td>
            {/*<td className="table_column">*/}
            {/*    <strong className="table_lable">Feeds Count</strong>*/}
            {/*    <div>*/}
            {/*        {item.count}*/}
            {/*    </div>*/}
            {/*</td>*/}
            {/*<td className="table_column column_action categories-td" onClick={() => setIsCaterogiesModalOpen(true)}>*/}
            {/*    <strong className="table_lable">Categories</strong>*/}
            {/*    <div>*/}
            {/*        {item.assignedCategories.length}*/}
            {/*    </div>*/}
            {/*</td>*/}
            <td className="table_column column_action">
                <strong className="table_lable">Limits</strong>
                <i style={{cursor: 'pointer', padding: '5px'}} className="fas fa-pencil-alt"
                   onClick={() => setIsLimitsModalOpen(true)}/>
            </td>
        </tr>
    );
}

export default OrganizationListItem;